import { AppStrings } from '../messages';

export const Portuguese: AppStrings = {
    or: ' ou ',
    max: 'máx.',
    accept: 'Aceitar',
    submit: 'Enviar',
    back: 'Retroceder',
    purchase: 'Comprar',
    no_thanks: 'Não, obrigado',
    thank_you: 'Obrigado!',
    cancel: 'Cancelar',
    close: 'Fechar',
    click_here_to_get_code: 'Clique aqui para obter seu código',
    open: 'Open',
    option_unavailable: 'De momento, não está disponível',
    confirm: 'Confirme',

    my_trip: 'A minha viagem',
    finalize_trip: 'Sua viagem está pronta',
    trip_all_set: 'Il tuo viaggio è pronto',
    trip_overview_capitalized: 'Visão Geral da Viagem',
    manage_guests_capitalized: 'Convide Pessoas',
    manage_guests_title: 'Convide pessoas',
    manage_pets_title: 'Adicionar/Remover Cães',
    manage_pets_error: 'Desculpe, ocorreu um erro. Para falar com um representante de atendimento ao cliente, ligue para 1-800-544-0300',
    add_remove_guest: 'Adicionar ou Remover Hóspede',
    modify_your_trip: 'Modifique sua viagem',
    instructions_for_modify_guests:
        'Informe-nos quantos adultos e crianças (com mais de 2 anos) vão ficar. Se seus planos ainda não foram finalizados, adicione os convidados que você conhece agora - você pode voltar e atualizar essas informações mais tarde.',
    instructions_for_modify_guests_pets:
        'Informe-nos quantos adultos, crianças (maiores de 2 anos) e cães ficarão hospedados. Se seus planos ainda não foram finalizados, adicione os convidados que você conhece agora. Você pode voltar e atualizar essas informações mais tarde.',

    instructions_for_modify_pets: 'Amigo peludo e rabos abanando são bem-vindos. Adicione até {pets} cães à sua estadia.',
    instructions_for_modify_pet: 'Amigo peludo e rabos abanando são bem-vindos. Adicione até 1 cão à sua estadia.',
    extra_instructions_for_modify_pet: 'Mudou sua mente? Reembolsaremos todas as taxas pagas por animais de estimação em até 5 dias úteis.',
    max_occupancy_modify_guests:
        'Máx. ocupação é de {max_occupancy} {guests}. Encargos adicionais podem ser aplicados e serão mostrados abaixo.',
    getting_there: 'Como chegar',
    in_the_home: 'Na casa',
    checkout_instructions: 'Instruções para o check-out',
    codes_will_be_provided: 'Os códigos serão fornecidos uma semana antes da data de check-in',
    passwords_will_be_provided: 'A palavra-passe será fornecida uma antes da data de check-in',
    alarm_code: 'Código do alarme',
    lockbox_code: 'Código da lockbox',
    e_lock_codes: 'Códigos E-Lock',
    gate_access: 'portão de acesso',
    stay_longer: 'Fique mais tempo',
    location_and_parking: 'Localização e estacionamento',
    on_your_way: 'A caminho',
    directions_to_know: 'Direções para saber',
    directions_and_parking_notes: 'Direções e estacionamento',
    parking_spaces: 'Lugares de estacionamento',
    parking_notes: 'Notas de estacionamento',
    entering_home: 'Entrar em casa',
    home_access_details: 'Detalhes de acesso à casa',
    house_rules: 'Regras da casa',
    internet_access: 'Acesso à Internet',
    network: 'Rede',
    password: 'Palavra-passe',

    reservation: 'Reserva',
    trip_overview: 'Visão geral da viagem',
    nights: 'Noites',
    max_occupancy: 'Ocupação máxima',
    can_add_guest: 'Você pode adicionar até {total} mais {guests}',
    can_not_add_guest: 'Você atingiu o número máximo de convidados',
    guest: 'Hóspede',
    guests: 'Hóspedes',
    confirmation: 'Confirmação',
    view_listing: 'Ver anúncio',

    rental_agreement: 'Contrato de arrendamento',
    sign_agreement: 'Assinar contrato',
    sign_by: 'Revise e assine {signBy}',
    sign_agreement_by: 'Assine as informações do contrato de arrendamento até {signBy}',
    signed_on: 'Assinado em {signedOn}',
    i_agree_terms: 'Concordo com os termos e as condições acima',
    agreed_on: 'Concordou com estes termos em {agreedOn}',
    i_agree_new_terms: `Concordo com o <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contrato de Locação</a> da Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Política de Privacidade</a>, e `,
    agreed_new_terms_on: `Você concordou com o <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contrato de Locação</a> da Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Política de Privacidade</a>, e `,
    agreed_new_terms_on_date: ` em {date}`,
    unit_terms_text: `Termos Específicos da Unidade`,
    unit_terms_alert: `A menos que seja declarado o contrário em `,
    new_terms_required_text: `Obrigatório`,
    new_terms_instructions_text: `Revise as regras da casa e confirme o acordo abaixo`,
    new_terms_submit_btn: `Enviar`,
    view_agreement: 'Ver contrato',
    print_header_text: 'Por favor, siga estas instruções. Você será notificado assim que recebermos e processarmos seu contrato',
    print_step_one: 'Imprimir, revisar e assinar este contrato',
    print_step_two: 'Envie-nos por email ou fax',
    print_button: 'Impressão',
    print_email_label: 'Email',
    print_fax_label: 'Fax',
    print_email_value: 'info@vacasa.com',
    print_fax_value: '(503) 897-7036',
    print_booked_by: 'Reservado por',
    print_on: 'em',

    payment_details: 'Detalhes de pagamento',
    make_payment: 'Realizar um pagamento',
    pay_balance: 'Pagar Saldo',
    balance_due: 'Saldo em dívida',
    payment_complete: 'Pagamento completo',
    pay_by: '{total} com vencimento em {payBy}',
    pay_balance_by: 'Pague seu saldo até {payBy}',
    view_receipt: 'Ver recibo',

    refund_going_to: 'Reembolso indo para',
    original_payment_methods: 'Método(s) de pagamento original',
    guest_paid: 'Convidado pagou {amount} em {date}',
    refund_details: 'Détails du remboursement',
    total_refund: 'Reembolso total',
    original_payment: 'Pagamento Original',

    cancellation_charges: 'Spese di cancellazione',
    sure_you_want_to_cancel: 'Tem certeza de que deseja cancelar sua viagem?',
    yes_cancel_now: 'Sim, cancelar agora.',
    no_dont_cancel: 'Não, não cancele.',
    cancel_trip: 'Cancelar viagem',
    cancel_and_receive_refund: 'Cancelar e receber reembolso',
    view_cancellation_policy: 'Ver Política de Cancelamento',

    balance_in: 'Saldo em {currency}',
    total_in: 'Total em {currency}',
    total_with_security_deposit_in: 'Total com depósito de segurança em {currency}',
    security_deposit: 'Depósito de segurança',
    new_balance_due: 'Novo Saldo em {currency}',
    processed_in_currency_notice: 'Esta transação foi processada em {currency}. As taxas de câmbio são aproximações variáveis.',

    vehicle_registration: 'Registro de Veículo',
    vehicle: 'Veículo',
    list_your_vehicles: 'Os veículos do seu grupo',
    register_vehicle: 'Registar veículo',
    max_vehicles_reached: 'Atingido o número máximo de veículos',
    group_has_no_vehicles: 'O meu grupo não tem veículos',
    register_by: 'Adicionar todos os veículos até {registerBy}',
    register_vehicles_by: 'Registe os seus veículos até {registerBy}',
    add_vehicle_info: 'Adicionar informações dos veículos',
    add_a_vehicle_button: 'Adicionar veículo',
    add_vehicle_title: 'Adicionar um veículo',
    add_vehicle_text: 'Adicione um veículo à sua viagem.',
    vehicle_added: 'Adicionada informação do veículo',
    edit_a_vehicle_button: 'Salvar Alterações',
    edit_vehicle_title: 'Editar um veículo',
    edit_vehicle_text: 'Edite as informações do seu veículo.',
    remove_vehicle_text: 'Remova um veículo da sua viagem.',
    remove_vehicle_title: 'Remover um veículo',
    remove_vehicle_button: 'Remover',
    my_group_has_no_vehicles_title: 'O meu grupo não tem veículos',
    my_group_has_no_vehicles_confirm_text:
        'Você pode ser multado pela prefeitura ou pelo HOA se o seu grupo trouxer veículo sem registrar com antecedência.',
    my_group_has_no_vehicles_confirm_button: 'Confirme nenhum Veículos',
    license_plate: 'Matrícula',
    state_province: 'Estado/província',
    other: 'De outros',
    location: 'Localização',

    add_on: 'Extra',
    pool_heat: 'Piscina aquecida',
    pool_heat_added: 'Adicionada piscina aquecida',
    pool_heat_note: 'Atualize sua estadia com nosso complemento de climatização de piscina! Mergulhe no conforto e no calor a cada nadada.',

    finalize_your_reservation: 'Finalize a sua reserva',
    these_actions_are_required: 'Você deve concluir esses itens de ação para obter os detalhes de check-in.',

    need_help: 'Precisa de ajuda?',
    visit_our: 'Visite a nossa ',
    support_center: 'Centro de Apoio',
    still_have_questions: 'Ainda tem perguntas?',
    please_reach: 'Contacte-nos: ',

    home_essentials: 'Informações básicas da casa',
    no_beds: 'Sem camas',
    king_bed: 'cama king',
    king_bed_plural: 'camas king',
    queen_bed: 'cama queen',
    queen_bed_plural: 'camas queen',
    double_bed: 'cama de casal',
    double_bed_plural: 'camas de casal',
    twin_bed: 'cama de solteiro',
    twin_bed_plural: 'camas de solteiro',
    child_bed: 'cama de criança',
    child_bed_plural: 'camas de criança',
    murphy_bed: 'cama dobrável',
    murphy_bed_plural: 'camas dobráveis',

    no_bathrooms: 'N.º casas de banho',
    full_bath: 'banho completo',
    full_bath_plural: 'banhos completos',
    half_bath: 'meio banho',
    half_bath_plural: 'banhos de meia',

    sleeps: 'Capacidade',

    loading: 'A carregar',
    updated_successfully: 'Atualizado com êxito',
    read_more: '...Ler mais',
    read_less: '...Ler menos',

    who_is_coming: 'Quem vem',
    invite_guest: 'Convidar hóspede',
    invite_guest_note: 'Os hóspedes convidados receberão um email de check-in {daysBefore} dias antes da data de check-in.',
    invite_guest_note_same_day: 'Os hóspedes convidados receberão um e-mail de check-in detalhado no dia da chegada',
    add_guest: 'Convidar hóspede',
    edit_guest: 'Editar hóspede',
    remove_guest: 'Remover hóspede',
    edit_guest_note_modal: 'Edite os seus hóspedes para partilhar o itinerário e informações sobre esta viagem.',
    invite_guest_info: 'Adicionar informações dos hóspedes',
    email_addresses_guests: 'Endereço de e-mail',
    modify_guest_note: 'Pode adicionar ou remover hóspedes da sua viagem.',
    modify_guest_add_note: 'Pode adicionar mais {remainingGuests} hóspedes',
    need_cancel_trip: 'Tem de cancelar a sua viagem?',
    need_cancel_note: 'Se tiver de cancelar a sua viagem, consulte as condições de cancelamento aqui.',
    cancel_trip_options: 'Veja as opções de cancelamento',
    name: 'Nome',
    first_name: 'Nome',
    last_name: 'Apelido',
    email_address: 'Endereço de email',
    invite_guest_note_modal: 'Adicione os seus hóspedes para partilhar o itinerário e informações sobre esta viagem.',
    yes_remove_invited: 'Sim',
    no_remove_invited: 'Nem pensar',
    can_add_pet: 'Adicione até {total} amigo peludo',
    can_add_pets: 'Adicione até {total} amigos peludos',
    can_not_add_pet: 'Você atingiu o número máximo de cachorros',
    add_pet_refund_btn: 'Recevoir un remboursement',
    add_pet_update_balance_title: 'Mettre à jour le solde',
    add_pet_checkout_title: 'Continuer le paiement',
    pet: 'Cão',
    pets: 'Cães',
    remove_invite_note: 'será removido da lista de hóspedes',
    are_you_sure: 'Tem a certeza?',

    cookie_disclaimer:
        'A Vacasa usa cookies próprios e de terceiros. Ao usar os nossos sítios Web, concorda com a nossa Política de Cookies.',
    read_cookie_policy: 'Leia a nossa Política de Cookies',

    sitemap: 'Mapa do Sítio',
    privacy: 'Privacidade',
    terms_of_service: 'Condições de Utilização',
    property_management: 'Gestão de Aluguel de Férias',
    real_estate: 'Imobiliário',
    innovation: 'Inovação',
    company: 'Empresa',
    about_us: 'Sobre nós',
    blog: 'Blog',
    careers: 'Carreiras',
    newsroom: 'Redação',
    investors: 'Investidores',
    community: 'Comunidade',
    social_responsibility: 'Responsabilidade social',
    leadership: 'Liderança',
    solutions_partnerships: 'Soluções e parcerias',
    accessibility: 'Acessibilidade',
    help: 'Ajuda',
    support_contact: 'Apoio e contactos',
    toll_free: 'Linha grátis:',
    local: 'Local:',
    covid_update: 'COVID-19 Updates',
    hi: 'Olá, ',
    my_trips: 'As minhas viagens',
    favorites: 'Favoritos',
    profile: 'Perfil',
    logout: 'Sair',
    owner_portal: 'Conta de Proprietário',
    owner_login: 'Portal do Proprietário',
    login: 'Login de hóspedes / Cadastro',
    find_my_trip: 'Encontrar a minha viagem',
    my_account: 'Entrar / Registrar-se',
    language_and_currency: 'Língua',

    somethings_not_right: 'Ocorreu um problema',
    an_error_occurred: 'Houve um erro ao processar seu pedido',
    try_later_or_call: 'Tente mais tarde ou telefone para o seu representante Vacasa através do número',
    reservation_info_unavailable: 'Informação Indisponível',

    something_went_wrong: 'Uh oh, algo deu errado',
    error_cancelling: 'Ocorreu um erro ao cancelar sua reserva.',
    contact_customer_service: 'Entre em contato com o atendimento ao cliente em {phone} para obter mais assistência',

    identity_check_required: 'É necessário verificar a sua identidade para continuar',
    verify_identity: 'Verifique a sua identidade',

    already_completed_idv: 'Você já completou?',
    click_here: 'Clique aqui',

    guest_portal_unavailable: 'O Trip Manager não está disponível',
    resolve_issues_calling: 'Para resolver esta questão, telefone para o seu representante Vacasa através do número',

    session_expired: 'Sessão expirada',
    session_expired_message: 'A sessão expirou. Está a ser redirecionado para',

    access_token_expired: 'Sessão expirada',
    access_token_expired_message: 'A sessão expirou. Você está sendo redirecionado para atualizar sua sessão.',

    getting_there_capitalized: 'Como chegar',
    modify_your_trip_capitalized: 'Modifique a sua viagem',
    checkout_instructions_capitalized: 'Instruções para o check-out',

    trip_eligibility_trip_already_started:
        'Viva! A sua viagem acabou de começar! Se ainda precisar de modificar a sua viagem, telefone para um representante Vacasa através do número',
    trip_eligibility_pending_payment: 'O seu pagamento está a ser processado. Volte daqui a 24 horas para modificar a sua viagem.',
    trip_eligibility_created_before_june_fourth_2018:
        'Se ainda precisar de modificar a sua viagem, telefone para um representante Vacasa através do número',
    trip_eligibility_negative_balance: 'O seu reembolso está a ser processado. Volte daqui a 24 horas para modificar a sua viagem.',
    trip_eligibility_not_allowed_for_occupancy: 'Lamentamos, mas não pode alterar os hóspedes/cães nesta reserva.',
    trip_eligibility_refund_in_progress: 'Você tem um reembolso em andamento. Aguarde até que seja processado para modificar sua ocupação',

    wheres_my_receipt: 'Onde está o recibo da minha reserva?',
    channel_receipt_note:
        'Você fez sua reserva através de um dos nossos parceiros de reserva. Por favor, entre em contato com a empresa com quem fez a reserva para acessar o seu recibo e informações de pagamento.',

    download_app_mobile_note: 'Easy check-in',
    download_app_mobile_title: 'Join us on the app!',

    payment_title: 'Faça um pagamento',
    receipt_title: 'Recibo',
    addons_title: 'Complementos de viagem',
    latecheckout_title: 'Adicionar check-out tardio',
    modify_trip_title: 'Modificar viagem',

    pool_heat_add_or_remove: 'Adicionar ou remover o calor da piscina',

    submit_guest_edition: 'Enviar edição de convidado',
    confirm_guest_remove: 'Confirmar remoção de convidado',

    ready_to_checkout: 'Pronto para finalizar a compra?',
    note_early_checkout:
        'Clique para confirmar que está fazendo check-out. Isso também notificará nossa equipe de limpeza de que você partiu.',
    checkout_now: 'Saindo agora',
    not_ready_yet: 'Eu não estou pronto ainda',
    all_set: 'Tudo pronto!',
    note_confirm_early_checkout: 'Obrigado, seu check-out está completo. Esperamos recebê-lo novamente em breve!',
    got_it: 'Não tem problema',
    note_cancel_early_cehckout:
        'Você pode fazer o check-out às {checkout}. Quando estiver pronto, clique no link de check-out novamente na mensagem de texto que lhe enviamos.',

    rent: 'Alugar',
    fees: 'Tarifas',
    taxes: 'Impostos',
    trip_protection: 'Proteção de viagem',
    not_purchased: 'Não comprado',
    previous_balance: 'Saldo anterior',
    sub_total: 'subtotal',
    pet_refund: 'Reembolso para animais de estimação',
    adult_added: 'Adulto adicionado',
    adults_added: 'Adultos adicionados',
    pet_added: 'Cachorro adicionado',
    pets_added: 'Cães adicionados',
    child_added: 'Criança adicionada',
    children_added: 'Crianças adicionadas',
    child: 'Criança',
    children: 'Crianças',

    payment_processed_by: 'Pagamento processado por:',
    billing_address: 'Endereço de cobrança:',

    view_receipt_capitalized: 'Siehe Quittung',

    receipt_thirty_party_channel: 'Obrigado por reservar sua casa Vacasa através {channel}',

    covid19_text: 'An update on coronavirus (COVID-19) and our cancellation policies',
    covid19_button_text: 'Read Our Latest Updates',
    covid19_link: 'https://www.vacasa.com/support/coronavirus-covid-19',

    square_feet: 'pés quadrados',

    browser_deprecated: 'Navegador não suportado',
    please_upgrade_browser: 'Por favor, atualize ou use outro navegador para visualizar este site',

    know_before_you_go: 'Saiba antes de ir',
    import_details: 'Detalhes importantes',
    directions_and_parking_details: 'Instruções e detalhes de estacionamento',
    note_for_our_guests: 'Notas para os nossos hóspedes',

    cannot_perform_action_title: 'Esta página não está disponível no momento',
    cannot_perform_action_message: 'Tente mais tarde ou telefone para o seu representante Vacasa através do número',

    fsc_credits: 'Future Stay Credits',

    address: 'Endereço',
    features_and_amenities: 'Recursos e comodidades',
    features_and_amenities_capitalized: 'Recursos e Comodidades',

    cancel_trip_title: 'Cancele sua viagem',
    cancel_your_reservation: 'Cancele sua Reserva',

    payment_form_add_night: 'Adicionar uma noite',
    payment_form_add_night_note: 'Seu novo horário de check-out será',
    payment_form_pricing_details: 'Detalhes de preços',
    payment_form_pricing_discounted_rent: 'Aluguel com desconto',
    payment_form_pricing_discount: 'Desconto',
    payment_form_total: 'Total',
    payment_form_billing_information: 'Informações de pagamento',
    payment_form_billing_name: 'Nome de cobrança',
    payment_form_country: 'País',
    payment_form_city: 'Cidade',
    payment_form_island: 'Ilha',
    payment_form_governorate: 'Governatorato',
    payment_form_province: 'Província',
    payment_form_department: 'Departamento',
    payment_form_state: 'Estado',
    payment_form_postal_code: 'Código Postal',
    payment_form_zip_code: 'Código Postal',
    payment_form_city_or_town: 'Cidade',
    payment_form_area: 'Área',
    payment_form_region: 'Região',
    payment_form_county: 'Município',
    payment_form_parish: 'Freguesia',
    payment_form_prefecture: 'Prefeitura',
    payment_form_emirate: 'Emirado',
    payment_form_card_number: 'Número do cartão',
    payment_form_expiration_date: 'Data de validade',
    payment_form_expiration_month: 'Mês de validade',
    payment_form_expiration_year: 'Ano de Expiração',
    payment_form_security_code: 'Código de segurança',
    payment_form_payments_note: 'Aceitamos a maioria dos principais cartões de crédito',
    payment_form_pay_now: 'Pague agora',
    payment_form_visa: 'Visa',
    payment_form_master_card: 'Master',
    payment_form_discover: 'Discover',
    payment_form_reservation_details: 'Detalhes da reserva',
    payment_form_adult: 'Adulto',
    payment_form_adults: 'Adultos',
    payment_form_child: 'Criança',
    payment_form_children: 'Crianças',
    payment_form_month: 'Mês',
    payment_form_year: 'Ano',
    payment_successful: 'Tudo pronto!',
    payment_successful_note:
        'Aproveite aquela noite extra de férias. Abaixo você encontrará seus detalhes de pagamento e verifique sua caixa de entrada para um e-mail de confirmação com as novas datas de viagem.',
    payment_failed: 'Não foi possível processar seu pagamento',
    payment_call_us_to_complete: 'Não se preocupe - por enquanto, estamos reservando uma noite extra para você.',
    payment_call_us_to_complete_start: 'Ligue para',
    payment_call_us_to_complete_end: 'para pagar via telefone e confirme a alteração em sua viagem.',
    payment_form_removed: 'Removido',
    payment_form_added: 'Adicionado',
    payment_successful_generic_note: 'Sua viagem está atualizada. Aqui está sua confirmação de pagamento.',
    payment_trip_paid_in_full: 'Sua viagem é paga integralmente.',
    payment_successful_add_pet_adjustment_note:
        'Você adicionou {total} {pet} à sua estadia. Deixe o rabo balançar. Aqui está sua confirmação de pagamento.',
    payment_successful_add_pet_adjustment_refund_note:
        'Você removeu {total} {pet} da sua estadia. Reembolsaremos todas as taxas de animais de estimação pagas dentro de 5 dias úteis.',
    payment_successful_add_pool_heat_adjustment_note:
        'Você adicionou o aquecimento da piscina à sua estadia. Aqui está a confirmação do seu pagamento.',

    modal_adjustment_not_available_continue: 'Continuar',
    modal_adjustment_not_available_back_to_trip: 'Voltar para detalhes da viagem',
    modal_adjustment_not_available_title: 'Esta noite não está mais disponível',
    modal_adjustment_not_available_note_start:
        'Não podemos adicionar a noite extra à sua viagem. (Outro convidado já fez a reserva ou o negócio expirou.)',
    modal_adjustment_not_available_note_end: 'Esperamos que você ainda tenha uma ótima estadia!',

    modal_adjustment_pending_balance_title: 'Pague seu saldo para desbloquear este negócio',
    modal_adjustment_pending_balance_note_start: 'Antes de adicionar uma noite, você precisará pagar o saldo atual da viagem.',
    modal_adjustment_pending_balance_note_end: 'Depois de pagar, você pode voltar para seu e-mail e tentar novamente.',

    modal_lco_adjustment_not_available_title: 'Check-out tardio não disponível',
    modal_lco_adjustment_not_available_note_start:
        'Desculpe, não é possível adicionar o check-out tardio à sua estadia. (a oferta expirou)',
    modal_lco_adjustment_pending_balance_note_start:
        'Antes de adicionar o check-out tardio, você precisará pagar o saldo pendente da sua viagem.',

    night_added: 'noite adicionada',
    nights_added: 'noites adicionadas',

    maintenance_window_title: 'This page is under maintenance',
    maintenance_window_note: 'We will be live again very soon. Thanks for you patience',
    maintenance_go_to_home: 'Go to Homepage',
    maintenance_link: 'https://www.vacasa.com',

    modal_cancel_go_to_my_trips: 'Go to My Trips',
    modal_cancel_title: 'Canceled reservation',
    modal_cancel_note: 'Your reservation has been successfully canceled',

    billing_information_note: 'Si prega di rivedere le modifiche e confermare per completare gli aggiornamenti di viaggio.',

    adjustment_failed_title: 'Não foi possível modificar sua viagem',

    whats_nearby: 'O que há por perto',
    whats_nearby_capitalized: 'O Que há Por Perto',
    checkout_best_of_city:
        'Confira o melhor de {unitCity} enquanto estiver aqui. Explore restaurantes populares, atrações e muito mais ao redor de {unitName}.',
    banking: 'Banco',
    restaurants_and_coffee: 'Restaurantes e cafés',
    groceries: 'Supermercados',
    hospitals: 'Hospitais',
    movie_theaters: 'Cinemas',
    bars_and_nightlife: 'Bares e vida noturna',
    parks: 'Parques',
    pharmacies: 'Farmácias',
    shopping: 'Compras',
    sports: 'Esporte',
    universities: 'Universidades',
    tourist_attractions: 'Atrações turísticas',
    filter_by_category: 'Filtrar por categoria',

    star_rating_title: 'Reveja a sua estadia',
    star_rating_note: 'Como foi sua experiência em {unitName}? A sua opinião é importante para nós.',
    next: 'Próximo',

    pay_balance_issue: 'Ligue para {phone} para pagar e confirmar a alteração da sua viagem.',

    chat_default_message: 'Olá, como podemos ajudá-lo hoje?',
    chat_default_name: 'Vacasa Customer Service',
    chat_start_new_button: 'Iniciar novo bate-papo',
    chat_start_content: 'Obrigado por conversar conosco!',
    chat_open: 'O bate-papo ao vivo está disponível',
    chat_message_close:
        'Infelizmente, você entrou em contato conosco fora do horário de bate-papo ao vivo. Para assistência imediata, ligue para nossa linha de suporte 24 horas.',
    chat_rule_close: '{openTime} às {closeTime}.',
    chat_rule: 'diariamente das {openTime} às {closeTime}.',
    chat_error: 'Erro ao inicializar o bate-papo',
    chat_loading: 'carregando...',
    chat_me: 'Min',

    extended_stay_capitalized: 'Estende Minha Estadia',
    extended_stay_rules: 'Selecione até 4 noites adicionais antes ou depois de sua viagem programada para prolongar sua estadia.',
    extended_stay_success_alert_plural: '<b>{numberNights} noites</b> adicionadas ao seu itinerário por <b>{price}</b>',
    extended_stay_success_alert: '<b>1 noite</b> adicionada ao seu itinerário por <b>{price}</b>',
    extended_stay_error_message:
        'Desculpe, ocorreu um erro. Para falar com um representante de atendimento ao cliente, ligue para 1-800-544-0300',
    extended_stay_note_message: 'Suas novas datas de check in e check out serão',
    check_in: 'Check in',
    check_in_description: 'Datas de check in mais cedo disponíveis:',
    check_out: 'Check out',
    adult: 'Adulto',
    adults: 'Adultos',
    check_out_description: 'Datas de check out disponíveis posteriormente:',
    empty_calendar_before_options: '* Infelizmente, todas as datas anteriores à sua viagem estão indisponíveis.',
    empty_calendar_after_options: '* Infelizmente todas as datas após a sua viagem estão indisponíveis.',
    payment_form_add_extended_stay: '{days} Noites Adicionais',
    today: 'Hoje',
    clear: 'Limpar',
    checkout: 'Check-Out',
    reset_dates: 'Redefinir Datas',
    total_cost: 'Custo total',

    late_check_out_capitalized: 'Adicionar check-out tardio',
    payment_form_add_late_check_out_note: 'Seu novo horário de check-out será',
    payment_form_add_late_check_out: 'Check-out tardio adicionado',

    bedroom_title: 'Acomodações para dormir',
    view_all_beds: 'Ver todas as {total} opções de acomodação para dormir',
    view_less: 'Ver menos',
    view_more: 'Ver mais',

    pool_heat_capitalized: 'Adicionar climatização de piscina',

    pal_res_question_panel_text:
        'Este imóvel é gerido por {name}. Para suporte, por favor envie um e-mail para {email} ou ligue para nós em {phoneNumber}.',
    pal_res_question_panel_text_email_only: 'Este imóvel é gerido por {name}. Para suporte, por favor envie um e-mail para {email}.',
    pal_res_question_panel_text_phone_only: 'Este imóvel é gerido por {name}. Para suporte, ligue para nós em {phoneNumber}.',

    pal_cancellation_contact_text:
        'Para solicitar um cancelamento, por favor entre em contato com {name} enviando um e-mail para {email} ou ligando para {phoneNumber}.',
    pal_cancellation_contact_text_email_only:
        'Para solicitar um cancelamento, por favor entre em contato com {name} enviando um e-mail para {email}.',
    pal_cancellation_contact_text_phone_only:
        'Para solicitar um cancelamento, por favor entre em contato com {name} ligando para {phoneNumber}.',

    pal_agreement_details_house_rules_text:
        'Reserve um momento para revisar as regras da casa abaixo. Elas se aplicam à sua estadia neste imóvel.',
    rental_terms: 'Condições de aluguel',
    view_terms: 'Ver termos',
    request_cancellation: 'Solicitar cancelamento',
    review_cancellation_policy: 'Revisar política de cancelamento',
    pricing_details: 'Detalhes de preços',
    view_details: 'Ver detalhes',
};
